'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.controller("zipDownloadPopinController", function ($scope, $fileDownload, $uiBlock) {
  $scope.params = {
    nodeId: $scope.nodeId,
    nbDocs: $scope.nbDocs,
    nbDocsRec: $scope.nbDocsRec,
    size: $scope.size,
    sizeRec: $scope.sizeRec,
    recursive: false
  };
  $scope.MAX_FILES_SIZE = 150 * 1024 * 1024;
  $scope.selectionIsTooBig = function () {
    console.log('Rec', $scope.params.sizeRec, $scope.MAX_FILES_SIZE, $scope.params.sizeRec > $scope.MAX_FILES_SIZE);
    return $scope.params.recursive ? $scope.params.sizeRec > $scope.MAX_FILES_SIZE : $scope.params.size > $scope.MAX_FILES_SIZE;
  };
  $scope.downloadAndClose = function () {
    $uiBlock.block();
    $fileDownload.start('/rest/documents/downloadZIP/' + $scope.params.nodeId + "/" + $scope.params.recursive).finally(function () {
      $uiBlock.unblock();
    });
    $scope.$close();
  };
  $scope.nbDocsATelecharger = function () {
    return $scope.params.recursive ? $scope.params.nbDocsRec : $scope.params.nbDocs;
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/inventaire/documents/zipDownloadPopin.js
// module id = 2829
// module chunks = 13